import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { TransitionGroup, CSSTransition } from 'react-transition-group'
import { withTranslation } from 'react-i18next';

import Alert from './alert';

class SocketErrorAlert extends PureComponent {
    state = {
        errorSolved: false
    }

    componentDidUpdate(prevProps) {
        if (!this.props.hasError && prevProps.hasError) {
            this.setState({
                errorSolved: true
            }, () => {
                setTimeout(() => {
                    this.setState({
                        errorSolved: false
                    });
                }, 3000);
            });
        }
    }

    render() {
        const { t } = this.props;

        return (
            <React.Fragment>
                {
                    this.props.hasError ? (
                        <CSSTransition key="socket-error" timeout={300} classNames="alert">
                            <Alert type="default" icon={<i className="icon material-icons">error</i>} visible={true}>
                                 { t('socket.error') }
                            </Alert>
                        </CSSTransition>
                    ) : null
                }
                {
                    this.state.errorSolved ? (
                        <CSSTransition key="socket-error" timeout={300} classNames="alert">
                            <Alert type="success" icon={<i className="icon material-icons">check_circle</i>} visible={this.state.errorSolved}>
                                 { t('socket.resolved') }
                            </Alert>
                        </CSSTransition>
                    ) : null
                }
            </React.Fragment>
        )
    }
}

export default withTranslation('errors')(SocketErrorAlert);
